import {
  STEPS_PER_MULTI_INSTALL,
  STEPS_PER_SINGLE_INSTALL,
} from '../constants';

type CreateProgressStoreParams = {
  appDefinitionIds: string[];
};

export class ProgressStore {
  private totalApps: number;
  private isSingleApp: boolean;
  private stepsPerApp: number;
  private currentAppStep: number;
  private installedCounter: number;

  constructor(params: CreateProgressStoreParams) {
    this.totalApps = params.appDefinitionIds.length;
    this.isSingleApp = params.appDefinitionIds.length === 1;
    this.stepsPerApp = this.isSingleApp
      ? STEPS_PER_SINGLE_INSTALL
      : STEPS_PER_MULTI_INSTALL;
    this.currentAppStep = 1;
    this.installedCounter = 0;
  }

  public incrementCurrentAppStep() {
    this.currentAppStep += 1;
  }

  public incrementInstalledCounter() {
    this.installedCounter += 1;
  }

  public getCurrentAppStep() {
    return this.currentAppStep;
  }

  public setCurrentAppStep(value: number) {
    this.currentAppStep = value;
  }

  public getCurrentStep() {
    return this.installedCounter * this.stepsPerApp + this.currentAppStep;
  }

  public getInstalledCounter() {
    return this.installedCounter;
  }

  public getTotalApps() {
    return this.totalApps;
  }

  public getTotalSteps() {
    return this.totalApps * this.stepsPerApp + 1;
  }

  public getStepsPerApp() {
    return this.stepsPerApp;
  }
}
